import React, { useRef, useState } from "react";
import styles from "./AudioPage.module.css";
import demoAudio from "../../Images/audio1.mp3";

const audioData = [
  { name: "Startup Loan", rec: demoAudio },
  { name: "Bridge Loans", rec: demoAudio },
  { name: "Gold Loan", rec: demoAudio },
  { name: "Home Equity Loans", rec: demoAudio },
  { name: "Data Collection", rec: demoAudio },
  { name: "Survey Department", rec: demoAudio },
  { name: "Debt Consolidation Loans", rec: demoAudio },
  { name: "Investment Property Loans", rec: demoAudio },
  { name: "Auto Loans", rec: demoAudio },
  { name: "Refinancing Services", rec: demoAudio },
  { name: "Receptionist", rec: demoAudio },
  { name: "Dept Collection", rec: demoAudio },
  { name: "Dealership", rec: demoAudio },
  { name: "Loan", rec: demoAudio },
  { name: "Lead Generation", rec: demoAudio },
  { name: "Hospital", rec: demoAudio },
  { name: "School", rec: demoAudio },
  { name: "Retail", rec: demoAudio },
  { name: "Real Estate", rec: demoAudio },
  { name: "Hospitality", rec: demoAudio },
  { name: "Travel and Tourism", rec: demoAudio },
  { name: "Telecommunications", rec: demoAudio },
  { name: "Customer Support", rec: demoAudio },
  { name: "Non-Profit", rec: demoAudio },
  { name: "Legal Services", rec: demoAudio },
  { name: "Fitness and Wellness", rec: demoAudio },
  { name: "Event Management", rec: demoAudio },
  { name: "Logistics and Delivery", rec: demoAudio },
  { name: "Government Services", rec: demoAudio },
  { name: "Entertainment", rec: demoAudio },
  { name: "Manufacturing", rec: demoAudio },
];

const AudioPage = () => {
  const audioRefs = useRef([]);
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const [filter, setFilter] = useState("");

  const handlePlay = (index) => {
    if (currentPlayingIndex !== null && currentPlayingIndex !== index) {
      const currentAudio = audioRefs.current[currentPlayingIndex];
      if (currentAudio) currentAudio.pause();
    }
    setCurrentPlayingIndex(index);
  };

  const filteredAudioData = audioData.filter((item) =>
    item.name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <h2>Explore Audio Features</h2>
      <hr />
      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search by name..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.audioContainer}>
        {filteredAudioData.length > 0 ? (
          filteredAudioData.map((item, index) => (
            <div className={styles.card} key={index}>
              <p className={styles.title}>{item.name}</p>
              <audio
                controls
                className={styles.audio}
                ref={(el) => (audioRefs.current[index] = el)}
                onPlay={() => handlePlay(index)}
              >
                <source src={item.rec} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          ))
        ) : (
          <p className={styles.noResults}>No results found.</p>
        )}
      </div>

      {/* Background shapes */}
      <div className={styles.backgroundShapes}>
        {[...Array(6)].map((_, i) => (
          <React.Fragment key={i}>
            <span className={`${styles.bubble} ${styles[`b${i + 1}`]}`}></span>
            <span className={`${styles.triangle} ${styles[`t${i + 1}`]}`}></span>
            <span className={`${styles.rectangle} ${styles[`r${i + 1}`]}`}></span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AudioPage;